import Vue from "vue";
import Vuex from "vuex";
import userModule from "./modules/user";
import groupsViewModule from "./modules/groupsView";
import adminModule from "./modules/admin.js";
import institutionModule from "@/store/modules/institution";
import filtersModule from "./modules/filters";
import dashboardModule from "./modules/dashboard";
import navigationModule from "./modules/navigation";
import themeModule from "./modules/theme";
import thermometryModules from 'sw-studio-thermometry/src/store';
import alertsModule from "./modules/alerts";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ...thermometryModules,
    user: userModule,
    groupsView: groupsViewModule,
    admin: adminModule,
    institution: institutionModule,
    filters: filtersModule,
    dashboard: dashboardModule,
    navigation: navigationModule,
    theme: themeModule,
    alerts: alertsModule
  },
});
